**Important Disclosures**

These important disclosures are deemed to be incorporated by reference
in its entirety into the WITH.CO website at
[with.co](https://with.co) (the "Site" or "WITH.CO Platform") and
any social media communication, advertisement, email or other
communication or disclosure which contains an active hyperlink or URL to
this page. The information contained herein neither constitutes an offer
for nor a solicitation of interest in any specific securities offering.

**General Information**

With Studios Inc. (together with its affiliated entities, collectively
\"WITH.CO\" or "we") operates a website at with.co. The information
contained on the Site is generally available to non-members (i.e.
persons who have not established a user profile) and has been prepared
by WITH.CO without reference to any particular user's investment
requirements or financial situation. Potential investors are encouraged
to consult with professional tax, legal, and financial advisors before
making any investment decision. All investments involve risk, including
the risk of the loss of all of your invested capital. Please carefully
consider the investment objectives, risks, and expenses related to an
investment prior to deciding to invest. Investment decisions should be
based on an individual's own goals, time horizon, and tolerance for
risk.

Information on the Site has been prepared by With Studios Inc.
("WITH.CO") without reference to any particular individual's investment
goals or financial situation and may contain summary information
relating to potential or proposed WITH.CO offerings. Any such
information is preliminary, subject to change, and will be qualified in
its entirety by reference to the more detailed discussions contained in
the respective offering circular, if and when filed with the Securities
and Exchange Commission ("SEC") or other offering materials relating to
such Offering.

By using the WITH.CO website, you accept the WITH.CO Terms of Use (which
require that disputes be resolved through binding arbitration) and
Privacy Policy. Any person interested in investing in any WITH.CO
offering should review our disclosures and the most recent publicly
filed offering statement relating to that offering or applicable private
placement memorandum, a copy of which will be available on the Site and,
in the case of any Regulation A offerings, on the SEC's EDGAR website.

The Site is maintained by WITH.CO in its sole and absolute discretion
and WITH.CO is solely responsible for the content on this website. No
broker-dealer member of SEC or FINRA is or has been involved in the
development or dissemination of this website. Nothing contained herein
shall be deemed to be binding against, or to create any obligations or
commitment on the part of, any potential investor, small business, or
their respective affiliates.

Neither the SEC nor any state securities commission or regulatory
authority approved, passed upon or endorsed the merits of any investment
on the Site. Each investor should always carefully consider investments
in any security and be comfortable with his/her understanding of the
investment. Investors should not construe any materials on the Site as
tax, legal, financial or investment advice.

WITH.CO is not registered as an investment company under the Investment
Company Act of 1940, as amended (the "Investment Company Act") and the
securities do not have the benefit of the protections of the Investment
Company Act. Furthermore, we are not registered as an investment adviser
under the Investment Advisers Act of 1940, as amended (the "Investment
Advisers Act"), and the members of the Company will not have the benefit
of the protections of the Investment Advisers Act.

All product names, logos, and brands are property of their respective
owners. Use of these names, logos, and brands is for identification
purposes only, and does not imply endorsement or affiliation.

**Testing the Waters**

WITH.CO may, from time to time, engage in "testing the waters" under
Regulation A of the Securities Act of 1933, as amended, for the
offerings currently filed with (but not yet qualified by) the SEC. This
process allows companies to determine whether there may be interest in
an eventual offering of their securities. WITH.CO is not under any
obligation to make an offering under Regulation A. We may choose to make
an offering to some, but not all, of the people, who indicate an
interest in investing, and that offering might not be made under
Regulation A. If we go ahead with an offering, we will only be able to
make sales after we have filed an offering statement with the SEC and
the SEC has "qualified" the offering statement. The information in the
offering statement will be more complete than any information provided
on our website or in communications, and could differ in important ways.
You must consider fully the information provided in the offering
statement filed with (and qualified by) the SEC prior to making any
investment decision. No money or other consideration is being solicited
at this time for any pre-qualified offering, and if sent in response,
will not be accepted.

No offer to buy the securities for a pre-qualified offering can be
accepted and no part of the purchase price can be received by the issuer
or anyone else until the offering statement filed by the WITH.CO issuer
with the SEC has been qualified by the SEC. Any such offer may be
withdrawn or revoked, without obligation or commitment of any kind, at
any time before notice of acceptance is given after the date of
qualification. An indication of interest involves no obligation or
commitment of any kind by either party.

**Regulation A Offerings & Offering Circulars**

Any offering appearing on the Site that is made under Regulation A of
the Securities Act of 1933, as amended, will be made only by means of an
offering circular, which forms an integral part of an offering
statement, that has been qualified by the SEC. Any offering that is
available for investment means the SEC has qualified the offering
statement for such offering, which only means that the issuer of those
shares may make sales of the securities described by the offering
statement. It does not mean that the SEC has approved, passed upon the
merits of, or passed upon the accuracy or completeness of the
information in the offering statement.

Offerings appearing on the Site may be in one of three stages:

- Stage 1: The offering circular is in the process of being prepared,
  but not yet on file with the SEC.

- Stage 2: The preliminary offering circular has been filed with the
  SEC, but has not yet been qualified by the SEC. Note, it is not
  unusual for a preliminary offering circular to be filed several times
  prior to completion of the SEC review process.

- Stage 3: SEC review is complete, the offering circular is qualified
  and subscriptions and investment funds can be accepted.

In addition, it is possible that after an offering is commenced, we need
to update the offering circular to add or update material information,
in which case we may be required to suspend accepting subscriptions
until such revised offering circular has been reviewed by the SEC.

It is important to understand that the SEC does not pass upon the merits
of or give its approval to any securities offered or the terms of any
offering, nor does it pass upon the accuracy or completeness of any
offering circular or other solicitation materials.

If you are interested in investing in an offering, you should carefully
review the offering circular and other materials filed with the SEC
before making an investment decision. It is important to note that
information contained in a preliminary offering circular (i.e. Stage 2)
may change and such changes could be material, so even if you have
reviewed a preliminary offering circular, it is critical to review the
most recent offering circular on file with the SEC prior to subscribing
for shares and tendering payment.

Although the Regulation A offering structure is similar in many respects
to a registered initial public offering of shares in a traditional
public offering, Regulation A is an exemption from the registration
requirements of the Securities Act and there are important differences
between a Regulation A offering and a traditional "registered" public
offering, including, without limitation, the following:

_Limited Disclosure_. Disclosure rules applicable to issuers under
Regulation A are more limited in scope than those applicable to issuers
pursuing a traditional public offering, so there may not be as much
information included in the offering circular for an offering referenced
on the Site than there would be in a prospectus. In addition, ongoing
SEC reporting obligations for Regulation A issuers are also more limited
than requirements for typical companies.

_Not Subject to 34' Act Reporting; Proxy Rules, Insider Reporting_.
Traditional publicly traded companies are subject to certain ongoing
financial and material event reporting requirements, proxy rules
relating shareholder votes and reporting of transactions by insiders.
These requirements are not applicable to issuers of securities pursuant
to Regulation A, provided they comply with certain requirements which
WITH.CO intends to comply with.

_Less Restrictive Corporate Governance_. As a non-listed company
conducting an exempt offering pursuant to Regulation A, WITH.CO issuers
are not subject to a number of corporate governance requirements that
would apply to companies listed on national securities exchanges,
including the requirement to have a board of directors with a majority
of "independent" directors, independent committees and internal controls
audits. Accordingly, you may not have the same protections afforded to
shareholders of companies that are subject to all of the corporate
governance requirements of a company listed on a national stock
exchange.

_Lack of Liquidity_. Traditional initial public offering issuers list
their shares on a national securities exchange that makes it relatively
easy for market participants to trade the securities. The shares offered
by WITH.CO will not be listed on a national securities exchange and may
be illiquid. Accordingly, investors must be prepared to hold their
investment for an indefinite period.

**Obtain Your Own Advice**

None of the information on our Site should be construed as investment
advice. The information contained on the Site has been prepared by
WITH.CO without reference to any particular user's investment
requirements or financial situation. Potential investors are encouraged
to consult with professional tax, legal, and financial advisors before
making any investment into a WITH.CO offering.

**Risks of Investing**

Investing involves a number of significant risks and uncertainties. Each
WITH.CO issuer is undiversified, and investing in any given WITH.CO
issuer is risky since 100% of such investment is concentrated in a
single property. Please also review the "Risk Factors" section of our
SEC filings prior to investing. In addition, you should consult your own
counsel, accountant and other advisors as to legal, tax, business,
financial, and related aspects of an investment in a WITH.CO issuer.
Past performance is no guarantee of future results. An investor can lose
money. Investment decisions should be based on an individual's own
goals, time horizon, and tolerance for risk.

**Forward-Looking Statements**

The with.co website contains certain forward-looking statements that
are subject to various risks and uncertainties. Forward-looking
statements are generally identifiable by use of forward-looking
terminology such as "may," "will," "should," "potential," "intend,"
"expect," "outlook," "seek," "anticipate," "estimate," "approximately,"
"believe," "could," "project," "predict," or other similar words or
expressions. Forward-looking statements are based on certain
assumptions, discuss future expectations, describe future plans and
strategies, or state other forward-looking information. Our ability to
predict future events, actions, plans or strategies is inherently
uncertain and actual outcomes could differ materially from those set
forth or anticipated in our forward-looking statements. You are
cautioned not to place undue reliance on any of these forward-looking
statements.

**Miscellaneous**

_Notice to Foreign Investors_

The offering materials prepared by WITH.CO are directed solely to
persons located within the United States. If the recipient of the
materials lives outside the United States, it is their responsibility to
fully observe the laws of any relevant territory or jurisdiction outside
the United States in connection with any purchase of securities,
including obtaining required governmental or other consents or observing
any other required legal or other formalities. Unless otherwise
indicated in SEC offering materials, WITH.CO has not qualified the
offering of the shares in any jurisdiction outside the United States.

_IRA Investing_

The securities will not be offered or sold to prospective investors
subject to the Employee Retirement Income Security Act of 1974 and
regulations thereunder, as amended ("ERISA"). To the extent we do offer
securities to prospective investors subject to ERISA in the future, it
is important to understand that Individual Retirement Accounts ("IRA")
are subject to specific tax treatment by the Internal Revenue Service
("IRS") and contributions, earning, and withdrawals may have tax
implications. It is your responsibility to understand and comply with
IRS regulations regarding IRAs, including but not limited to eligibility
criteria, contribution limits, and distribution rules. Distributions are
taxable to the holder of the account and may be subject to early
withdrawal penalties of 10% of such amount if the investor is not at
least 59-½ years of age. For tax year 2025, IRA contributions may not
exceed the lesser of \$7,000 (\$8,000 if you're age 50 or older), or
your taxable compensation for the year. WITH.CO urges those investors
seeking to use their IRA to invest in WITH.CO offerings to consult with
a competent tax professional prior to making an investment decision. The
decision to open and fund an IRA is a self-directed action and does not
constitute a solicitation from the WITH.CO platform or any affiliated
entity. No WITH.CO affiliated entity has provided guidance regarding the
establishment or funding of an IRA, and you assume full responsibility
for all the implications and outcomes of investing through this method.

_Illiquidity_

There is no trading market for shares at this time and there can be no
assurance that such a market will develop in the foreseeable future.
Shares may not be resold or otherwise disposed of by an investor unless
there are available exemptions from registration under federal and
applicable state securities laws (and other requirements are met, which
may include an opinion of counsel), or such transfer is made in
compliance with the registration requirements of such laws. Accordingly,
investors must bear the risk of loss for an indefinite period of time.
